export const MAX_UPLOAD_ATTEMPTS = 10

// 100MB, the maximum chunksCount allowed is 100 in the serivces. So the file size limit is 10 GB for multipart upload
export const CHUNK_SIZE = 100000000
